import { config } from "../../utils/constants";
import axios from "axios";
import { getCurrentLocale, isLiferayEnv, isLoggedIn } from "../../utils/util";
import { oAuthRequest } from "../../utils/request";

export const getQuestionData = (questionRequestBody) => {
  const locale = getCurrentLocale();
  let data = {
    ...questionRequestBody,
    locale: locale
  };
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}questionData`,
    method: 'POST',
    data: data
  };
  return axios.request(requestConfig);
};

export const submitAnswerDataFe = (answerDataRequestBody) => {
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}submitAnswer`,
    method: 'POST',
    data: answerDataRequestBody
  };
  return axios.request(requestConfig);
};

export const getSubmittedAnswerData = (answerRequestBody) => {
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}submittedAnswerData`,
    method: 'POST',
    data: answerRequestBody
  };
  return axios.request(requestConfig);
};

export const generateBarCode = (content) => {
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}barcode`,
    method: "POST",
    data: {
      QrContent: content
    }
  };
  return axios.request(requestConfig);
};

export const submittedAnswerBarCodeData = (submitData) => {
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}submittedAnswerBarCodeData`,
    method: 'POST',
    data: submitData
  };
  return axios.request(requestConfig);
};

export const getSubmmitedBarCodeDataDetails = (mobileNo) => {
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}getBarCodeDataDetails/${mobileNo}`,
    method: 'GET'
  };
  return axios.request(requestConfig);
};

export const getSubmitedBarCodeDataDetailsByUserName = () => {
  const env = isLiferayEnv();
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}getBarCodeDataDetailsByUserName`,
    method: 'GET',
    params: {
      env
    }
  };
  if (env)
  {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const submitRegistrationData = (submitData) => {
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}submitRegistration`,
    method: 'POST',
    data: submitData
  };
  return axios.request(requestConfig);
};

export const getUserDetailsForBloodDonation = () => {
  const env = isLiferayEnv();
  const url = `${config.backendBaseAddress}${config.bloodDonationServices}userDetails`;
  const requestConfig = {
    url: url
  };
  if (env)
  {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const getPastDonationData = (emiratesId) => {
  const env = isLiferayEnv();
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}pastDonation`,
    params: {
      emiratesId,
      env
    }
  };

  if (env)
  {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const getCardProfileDataByEmiratesId = (emiratedId, userName) => {
  const env = isLiferayEnv();
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}cardProfileData`,
    params: {
      emiratedId,
      env,
      userName
    }
  };

  if (env)
  {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const getCardProfileDataByDonorId = (donorId, userName) => {
  const env = isLiferayEnv();
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}cardProfileDataByDonorId`,
    params: {
      donorId,
      env,
      userName
    }
  };

  if (env)
  {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const getWebContent = (webStructurePk, templateId) => {
  const locale = getCurrentLocale();
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}getWebcontentData`,
    method: "get",
    params: {
      webStructurePk,
      templateId,
      locale
    }
  };
  return axios.request(requestConfig);
};

export const createAndSendOtpRegistration = (mobileNo, fullName, bloodGroup) => {
  const locale = getCurrentLocale();
  // const env = isLiferayEnv();
  let requestBody = {
    mobileNo: mobileNo,
    locale: locale,
    additionalInfo: {
      fullName,
      bloodGroup
    }
  };
  const requestConfig = {
    method: "POST",
    url: `${config.backendBaseAddress}${config.bloodDonationServices}generateOtpAndAddInfo`,
    data: requestBody
  };
  return axios.request(requestConfig);
};

export const submitRegistration = (otp, id, mobileNo, fullName, bloodGroup) => {
  const locale = getCurrentLocale();
  let requestBody = {
    otp: otp,
    id: id,
    mobileNo: mobileNo,
    fullName: fullName,
    bloodGroup: bloodGroup,
    locale: locale
  };
  const requestConfig = {
    method: "POST",
    url: `${config.backendBaseAddress}${config.bloodDonationServices}submitRegistration`,
    data: requestBody
  };
  return axios.request(requestConfig);
};

export const createAndSendOtp = (mobileNo) => {
  const locale = getCurrentLocale();
  let requestBody = {
    mobileNo: mobileNo,
    locale: locale
  };
  const requestConfig = {
    method: "POST",
    url: `${config.backendBaseAddress}${config.bloodDonationServices}generateOtp`,
    data: requestBody
  };
  return axios.request(requestConfig);
};

export const verifyOtp = (otp, id) => {
  let requestBody = {
    otp: otp,
    id: id
  };
  const requestConfig = {
    method: "POST",
    url: `${config.backendBaseAddress}${config.bloodDonationServices}verifyOtp`,
    data: requestBody
  };
  return axios.request(requestConfig);
};


export const getPicklist = () => {
  const locale = getCurrentLocale();
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}getPicklist/${locale}`,
    method: "get"
  };
  return axios.request(requestConfig);
};

export const getDonorDetailsByDonorId = (donorId, userName) => {
  const env = isLiferayEnv();
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}getDonorDetailsDonorId`,
    method: "POST",
    data: {
      donorId: donorId,
      env: env,
      userName: userName
    }
  };

  if (env)
  {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const getDonorDetailsByEmiratesId = (emiratesId, userName) => {
  const env = isLiferayEnv();
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}getDonorDetailsEmiratesId`,
    method: "POST",
    data: {
      emiratesId: emiratesId,
      env: env,
      userName: userName
    }
  };

  if (env)
  {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const getDonorDetailsByUserName = () => {
  const env = isLiferayEnv();
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}getDonorDetailsUserName`,
    method: "GET"
  };
  if (env && isLoggedIn())
  {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const saveDonorDetails = (fullOtp, id, donorId, emiratesId, email, isVisible) => {
  const env = isLiferayEnv();
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}saveDonorDetails`,
    method: "POST",
    data: {
      otp: fullOtp,
      id: id,
      donorId: donorId,
      emiratesId: emiratesId,
      email: email,
      isVisible: isVisible
    }
  };

  if (env)
  {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const getIdamUserDetails = () => {
  const env = isLiferayEnv();
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}userType`,
    method: "get"
  };

  if (env)
  {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const getDonorPastDonations = (donorId) => {
  const env = isLiferayEnv();
  const requestConfig = {
    method: "GET",
    url: `${config.backendBaseAddress}${config.bloodDonationServices}pastDonorDetails`,
    params: {
      donorId,
      env
    }
  };
  if (env)
  {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const saveQrCodeAndSendSms = (uuid, qrCode, mobileNum) => {
  let cleanMobileNo = mobileNum.replace(/\+/g, "");
  const locale = getCurrentLocale();
  let requestBody = {
    uuid: uuid,
    qrCode: qrCode,
    mobileNumber: cleanMobileNo,
    locale: locale
  };
  const requestConfig = {
    method: "POST",
    url: `${config.backendBaseAddress}${config.bloodDonationServices}saveQrCodeAndSendSms`,
    data: requestBody
  };
  return axios.request(requestConfig);
};

export const getCardProfileDataLinkingAccount = (donorId, emiratesId, donorYear, emiratesYear, userName) => {
  const env = isLiferayEnv();
  const locale = getCurrentLocale();
  let dateOfBirth;
  if (donorYear)
  {
    dateOfBirth = donorYear;
  }
  if (emiratesYear)
  {
    dateOfBirth = emiratesYear;
  }
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}cardProfileDataLinkingAccount`,
    params: {
      donorId,
      emiratesId,
      env,
      userName,
      dateOfBirth,
      locale
    }
  };

  if (env)
  {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};

export const saveDonorDetailsLinkingAccount = (fullOtp, id, donorId, emiratesId, donorYear, emiratesYear, email, isVisible) => {
  const env = isLiferayEnv();
  let requestBody = {
    otp: fullOtp,
    id: id,
    donorId: donorId,
    emiratesId: emiratesId,
    email: email,
    isVisible: isVisible
  };
  if (donorYear)
  {
    requestBody.dateOfBirth = donorYear;
  }
  if (emiratesYear)
  {
    requestBody.dateOfBirth = emiratesYear;
  }
  const requestConfig = {
    url: `${config.backendBaseAddress}${config.bloodDonationServices}saveDonorDetailsLinkingAccount`,
    method: "POST",
    data: requestBody
  };

  if (env)
  {
    return oAuthRequest(requestConfig);
  }
  return axios.request(requestConfig);
};